export default [
  {
    path: '/active-gk100/index',
    name: 'index',
    component: () => import('@/views/active-gk100/index'),
    meta: {
      title: '2022高考人的愿望清单-高考直通车'
    }
  },
  
]
